import React, { Component } from 'react'

import { withStyles } from '@material-ui/core/styles';
import View from 'react-flexbox'
import { Typography, Divider, Card, TextField } from '@material-ui/core';
class ListaHistorico extends Component {
    constructor(props) {
        super(props)
        this.state = { uidUltimo: null, historicoArray: null }
    }
    componentWillReceiveProps(props) {
        if (props.uidObj && props.uidObj !== this.state.uidUltimo && props.customForm) {
            this.props.getHistorico(props.customForm, props.uidObj, (array) => {
                this.setState({ historicoArray: array })
            })
            this.setState({ uidUltimo: props.uidObj })
        }

    }
    renderItem(item, index) {

        const { classes, perfis } = this.props

        let nomeUsuario = "";

        if (perfis) {
            perfis.forEach(element => {
                if (element.uid === item.userLastChange) {
                    nomeUsuario = element.nome
                }
            });
        }
        return <Card key={index} className={classes.card}>
            <TextField
                label={"De:"}
                className={classes.cardContent}
                disabled
                multiline
                value={JSON.stringify(item.de)}
                fullWidth
                InputProps={{
                    style: { color: "#000" }
                }}
            />
            <TextField
                label={"Para:"}
                className={classes.cardContent}
                disabled
                multiline
                value={JSON.stringify(item.para)}
                fullWidth
                InputProps={{
                    style: { color: "#000" }
                }}
            />
            
            <View style={{ paddingLeft: 5, paddingRight: 10 }}>
                <Typography variant="caption" className={classes.cardData}>{item.data}</Typography>
                <Typography variant="caption" className={classes.cardData}>{nomeUsuario || item.userLastChange}</Typography>
            </View>
        </Card >
    }
    render() {
        const { historicoArray } = this.state
        if (historicoArray == null) {
            return "Sem Historico"
        }
        historicoArray.sort((a, b) => (a.data < b.data) ? 1 : ((b.data < a.data) ? -1 : 0))
        return (
            <div>
                {historicoArray.map((item, index) => this.renderItem(item, index))}
            </div>
        )
    }
}

const styles = {
    card: {

        margin: 5,
        padding: 5
    },

    cardContent: {
        paddingLeft: 5,
        paddingTop: 5,
        paddingRight: 5,

    },
    cardData: {
        paddingLeft: 5,


    },

};

export default withStyles(styles)(ListaHistorico);

export function dateToString(data) {

    if (!data) {
        return "";
    }
    try {
        data = data.toDate()
    } catch (error) {
        try {
            data = new Date(data.seconds * 1000)
        } catch (error) {

        }
    }
    try {


        var mm = data.getMonth() + 1; // getMonth() is zero-based
        var dd = data.getDate();
        var minutes = data.getMinutes();
        var hour = data.getHours();
        return [
            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            data.getFullYear(),
        ].join('/') + " " + hour + ":" + minutes;
    } catch (error) {

        console.log('error', error);
        console.log('data', data);

        return "erro"

    }
}


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Historico/components/ListaHistorico/ListaHistorico.js